import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Icon } from 'antd'
import Column from '../Column/Column'
import { reorder, reorderTasks } from '../../../helpers/reorder'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import scrumBoardActions from '../../../redux/scrumBoard/actions'
import { ParentContainer, Container, AddListButton } from './Board.style'
import { filterSearchedComponents } from '../../../helpers/searchTaskCard'
import BoardLayout from './BoardLayout/BoardLayout'
import modalActions from '../../../redux/modal/actions'
import reportAction from '../../../redux/report/actions'
import orgAction from '../../../redux/organization/actions'
import { notification } from 'antd'
function Board({
    currentBoard,
    openModal,
    boards,
    match,
    columns,
    moveColumnWatcher,
    tasks,
    moveTaskWatcher,
    ordered,
    containerHeight,
    withScrollableColumns = true,
    boardRenderWatcher,
    location,
    getListReportQueryByid,
    setBoardsData,
    loadListOrganization,
    getListOrgQueryById,
    getDetailTaskById,
    moveCardReport,
    lastIdTask,
    getActivityTask,
    getListOrgQueryByIdDone,
    userInfo,
}) {
    useEffect(() => {
        console.log('match data', match.params.id)
        console.log('ordered data', ordered)
        console.log('columns data board', columns)
        // get list org có tồn tại
        loadListOrganization(0)
        getDetailTaskById(match.params.id)
        getActivityTask(match.params.id, lastIdTask, 10)
        // boardRenderWatcher(match.params.id)
        const column = {
            column1: {
                id: 'column1',
                board_id: 'board-1',
                task_orders: [],
                title: 'Một số thông tin',
                editing: false,
            },
            column2: {
                id: 'column2',
                board_id: 'board-2',
                task_orders: [],
                title: 'Báo cáo hiện có',
                editing: false,
            },
            column3: {
                id: 'column3',
                board_id: 'board-1',
                task_orders: [],
                title: 'Báo cáo đã xem',
                editing: false,
            },
            column4: {
                id: 'column4',
                board_id: 'board-1',
                task_orders: [],
                title: 'Báo cáo cần làm lại',
                editing: false,
            },
            column5: {
                id: 'column5',
                board_id: 'board-1',
                task_orders: [],
                title: 'Báo cáo được chấp nhận',
                editing: false,
            },
        }
        // reset data khi unmount
        return () => {
            console.log('reset data')

            setBoardsData({ tasks: [], columns: column })
            getListOrgQueryByIdDone([])
        }
    }, [getDetailTaskById, match.params.id, loadListOrganization])
    console.log('containerHeight', containerHeight)

    const onDragEnd = ({ source, destination, type, draggableId }) => {
        if (source && destination && draggableId) {
            console.log('end drag source', source)
            console.log('end drag destination', destination)
            console.log('end drag type', type)
            console.log('end drag draggableId', draggableId)
            console.log('columns data', columns[source.droppableId])
            if (
                userInfo.actions.find(act => {
                    return act === 'TASK_EDIT'
                }) ||
                userInfo.tier_id === 100 ||
                userInfo.uid === currentBoard.owner_id
            ) {
                if (currentBoard.status !== 4) {
                    if (source.droppableId !== 'column1') {
                        moveCardReport(
                            source.index,
                            source.droppableId,
                            destination.index,
                            destination.droppableId,
                            draggableId,
                            match.params.id
                        )
                    }
                } else {
                    notification.error({
                        message: 'Nhiệm vụ đã kết thúc',
                    })
                }
            } else {
                notification.error({
                    message: 'Bạn không có quyền sửa đổi nhiệm vụ này',
                })
            }
        }

        // if (
        //     source.droppableId === destination.droppableId &&
        //     source.index === destination.index
        // ) {
        //     return
        // }

        // // reordering column
        // if (type === 'COLUMN') {
        //     const columnOrdered = reorder(
        //         ordered,
        //         source.index,
        //         destination.index
        //     )
        //     moveColumnWatcher({
        //         board_id: match.params.id,
        //         column_orders: columnOrdered,
        //     })
        //     return
        // }

        // const updatedColumns = reorderTasks({
        //     columns,
        //     source,
        //     destination,
        //     draggableId,
        // })
        // const draggedTask = tasks[draggableId]
        // const updatedTask = {
        //     ...draggedTask,
        //     column_id: destination.droppableId,
        // }
        // const updatedTasks = {
        //     ...tasks,
        //     [updatedTask.id]: updatedTask,
        // }
        // moveTaskWatcher({ columns: updatedColumns, tasks: updatedTasks })
    }
    console.log('tasks data', tasks)
    const board = (
        <Droppable
            droppableId="board"
            type="COLUMN"
            direction="horizontal"
            // ignoreContainerClipping={Boolean(containerHeight)}
        >
            {provided => (
                <Container>
                    {ordered &&
                        ordered.map((columnId, index) => {
                            const column = columns[columnId]
                            // const tasksWithinColumn = column.task_orders.map(
                            //     task_id =>
                            //         tasks.find(data => {
                            //             return (data.id = task_id)
                            //         })
                            // )
                            const tasksWithinColumn = []
                            column.task_orders.map(task_id => {
                                tasks.map(task => {
                                    if (task.id === task_id) {
                                        tasksWithinColumn.push(task)
                                    }
                                })
                            })

                            console.log('render column data', column)
                            console.log('tasksWithinColumn', tasksWithinColumn)

                            return (
                                <div
                                    style={{ padding: 10 }}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    <Column
                                        key={columnId}
                                        index={index}
                                        title={column.title}
                                        column={column}
                                        boardId={match.params.id}
                                        tasks={tasksWithinColumn}
                                        // isScrollable={withScrollableColumns}
                                    />
                                </div>
                            )
                        })}
                </Container>
            )}
        </Droppable>
    )

    return (
        <BoardLayout
            // currentBoard={location.state.data}
            boards={boards}
            match={match}
        >
            <DragDropContext onDragEnd={onDragEnd}>
                {containerHeight ? (
                    <ParentContainer height={containerHeight}></ParentContainer>
                ) : (
                    board
                )}
            </DragDropContext>
        </BoardLayout>
    )
}

export default connect(
    (state, ownProps) => {
        return {
            ordered: ['column1', 'column2', 'column3', 'column4', 'column5'],
            state: state.scrumBoard,
            boards: state.scrumBoard.boards,
            columns: filterSearchedComponents(
                state.scrumBoard.tasks,
                state.scrumBoard.columns,
                state.scrumBoard.searchText
            ),
            tasks: state.scrumBoard.tasks,
            currentBoard: state.scrumBoard.currentBoard,
            lastIdTask: state.scrumBoard.lastIdTask,
            userInfo: state.auth.userInfo,
        }
    },
    {
        ...scrumBoardActions,
        ...modalActions,
        ...reportAction.action,
        ...orgAction.action,
    }
)(Board)
